import { render, staticRenderFns } from "./FormUpload.vue?vue&type=template&id=f56ef542&"
import script from "./FormUpload.vue?vue&type=script&setup=true&lang=js&"
export * from "./FormUpload.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports